import { useMemo } from 'react';
import { useUserHasFeature } from 'src/hooks/useUserHasFeature';
import { Feature } from 'src/WebApiController';

import {
  DefaultYesNoFilterToolbarItemId,
  FilterToolbarItemId,
} from '../Filter.types';

export const useDefaultYesNoFilterValues = ({
  isReportsPage = false,
}: {
  isReportsPage?: boolean;
}) => {
  const hasDefaultYesNoFiltersFeature = useUserHasFeature(
    Feature.DefaultYesNoFilters
  );

  const shouldEnableEmptySelection = (
    filterId: FilterToolbarItemId
  ): boolean => {
    // If feature flag is off, always enable empty selection (current behavior)
    if (!hasDefaultYesNoFiltersFeature || isReportsPage) {
      return true;
    }
    // If feature flag is on, disable empty selection for filters in DefaultYesNoFilterToolbarItemId
    return !DefaultYesNoFilterToolbarItemId.includes(filterId);
  };

  // Define default values for specific filters
  const FILTER_DEFAULTS: Record<string, unknown> = useMemo(() => {
    if (!hasDefaultYesNoFiltersFeature) {
      return {};
    }
    const defaults: Record<string, unknown> = {};
    // Set all DefaultYesNoFilterToolbarItemId filters to default to true
    DefaultYesNoFilterToolbarItemId.forEach((filterId) => {
      defaults[filterId] = true;
    });
    return defaults;
  }, [hasDefaultYesNoFiltersFeature]);

  return {
    hasDefaultYesNoFiltersFeature,
    yesNoFilterDefaults: FILTER_DEFAULTS,
    shouldEnableEmptySelection,
  };
};
